$(document).click(function (e) {
    var map = $('#tway-map iframe');
    var container = $('#tway-map #map-container');
    if(e.target.id === 'tway-map' || e.target.id === 'map-container') {
        container.addClass('disabled');
        container.on('transitionend webkitTransitionEnd oTransitionEnd', function () {
            container.attr('style' , 'display: none;');
            map.attr('style', 'pointer-events: all;');
        });
    }else{
        map.attr('style', 'pointer-events: none;');
        container.attr('style' , '');
        container.removeClass('disabled');
    }
});



// WEBPACK FOOTER //
// ./assets/js/map.js